import { useQuery } from '@tanstack/react-query'

import { FetchIntakeForms } from '@/services/IntakeFormService'

/** Every intake form an organization has, one entry per form. */
export const useIntakeForms = (orgId: string) => {
  return useQuery({
    queryKey: ['intakeForms', orgId],
    queryFn: () => FetchIntakeForms(orgId),
    enabled: orgId !== '',
  })
}
